const groups = {
    'kap': {
        functionId: '4dc272d8-dab5-4609-96b1-11ca3a541264',
        name: 'Kapoenen',
        activityEditorCode: '1xKE80SO0QoQxaROiRJ8RzdJPnjwhWvjTSEesH34bUog',
        airtableId: 'recq7AH6KDrVm66CP',
    },
    'wel': {
        functionId: '202f1406-c44a-45af-97ee-cf99c737e6c3',
        name: 'Welpen',
        activityEditorCode: '1bGSzL8K0zx86W6jI5N32pIIqYVQynNsCJLc2ZmXvruo',
        airtableId: 'recca3Cvq2Avjs2bd',
    },
    'wol': {
        functionId: '0f4ce943-7691-4bd9-a0bd-94dc6b4d9cc0',
        name: 'Woudlopers',
        activityEditorCode: '1lOvvTJz47P3rydZ2z0oAuJQua0PMvA4rTFS4PNMrFjc',
        airtableId: 'reclqfn5J9T2YiDZ0',
    },
    'jgv': {
        functionId: 'a8c69856-8684-4cda-b2c9-031ba7437bf5',
        name: 'Jonggivers',
        activityEditorCode: '1SXHACHIvb33MOJfQsj9ODvUWRtUvgPgT9P1Tdjz6rzM',
        airtableId: 'rec6XRorDOdvUAUpo',
    },
    'giv': {
        functionId: '44099af5-3c73-4c39-9848-5fb304beb7a7',
        name: 'Givers',
        activityEditorCode: '1UUIe4eFn_kZtawg_M6v4vuBm1zyRqxyLJFKUGSumpas',
        airtableId: 'rectCb94KEmIxxVSy',
    },
}

export const groupsToArray = Object.entries(groups);

export default groups;